import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRight, Check, Clock, ShieldCheck, Zap } from 'lucide-react';
export function HeroSection() {
  return <div className="relative min-h-screen flex flex-col" data-id="element-33">
      {/* Background Image Container */}
      <div className="absolute inset-0 z-0" data-id="element-34">
        <img src="https://cdn.magicpatterns.com/uploads/j1XSRA6tEdbk2TgRFkLCEi/Pagina_de_venta.png" alt="Professional woman working calmly with ocean view" className="w-full h-full object-cover object-[70%_center] md:object-center" data-id="element-35" />
        {/* Mobile: strong top-to-bottom cream overlay so text is always readable */}
        <div className="absolute inset-0 bg-brand-cream/90 md:bg-transparent" data-id="element-36" />
        {/* Desktop: left-to-right gradient */}
        <div className="hidden md:block absolute inset-0 bg-gradient-to-r from-brand-cream/95 via-brand-cream/80 to-transparent" data-id="element-37" />
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-brand-cream to-transparent" data-id="element-38" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex items-center px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-39">
        <div className="max-w-7xl mx-auto w-full" data-id="element-40">
          <div className="max-w-2xl" data-id="element-41">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} data-id="element-42">
              <span className="inline-block py-1 px-3 rounded-full bg-brand-gold/20 text-brand-gold-dark text-xs sm:text-sm font-semibold tracking-wide mb-5 border border-brand-gold/30" data-id="element-43">
                PARA EMPRENDEDORES & CEOs
              </span>

              <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-brand-charcoal-dark leading-tight mb-5" data-id="element-44">
                Recupera tu Foco.{' '}
                <span className="text-brand-gold-dark" data-id="element-45">Domina tu Estrés.</span>{' '}
                Alcanza el Éxito.
              </h1>

              <p className="text-base sm:text-lg md:text-2xl text-brand-charcoal/80 mb-7 font-light leading-relaxed" data-id="element-46">
                El protocolo de 7 minutos que los CEOs de alto rendimiento usan
                para eliminar la neblina mental y operar en su máximo potencial.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-7" data-id="element-47">
                <Button size="lg" className="w-full sm:w-auto text-base sm:text-lg font-serif shadow-lg shadow-brand-gold/20" onClick={() => {
                window.open('https://thehabitbalance.com/cart/51805726671131:1', '_blank');
              }} data-id="element-48">
                  Quiero Recuperar Mi Enfoque{' '}
                  <ArrowRight className="ml-2 h-5 w-5 flex-shrink-0" data-id="element-49" />
                </Button>
              </div>

              <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 text-sm font-medium text-brand-charcoal/70" data-id="element-50">
                <div className="flex items-center" data-id="element-51">
                  <Clock className="h-4 w-4 text-brand-gold-dark mr-2 flex-shrink-0" data-id="element-52" />
                  Resultados en 7 minutos
                </div>
                <div className="flex items-center" data-id="element-53">
                  <Zap className="h-4 w-4 text-brand-gold-dark mr-2 flex-shrink-0" data-id="element-54" />
                  Sin estimulantes
                </div>
                <div className="flex items-center" data-id="element-55">
                  <ShieldCheck className="h-4 w-4 text-brand-gold-dark mr-2 flex-shrink-0" data-id="element-56" />
                  Garantía de 30 días
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>;
}